export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-2560x1440-de75fab8b04a43f91d6fbb42d8968bf4.jpg";